Shopify.linkOptionSelectorsUpsell = function(product, parent) {
  // console.log('--------------------linkOptionSelectorsUpsell()')
  const productTitle = product.metafields.accentuate.colorway.replace(/\s+/g, '');
  const productProperty = `optionsMap_${productTitle}`;
  // Building our mapping objects.
  Shopify[productProperty] = {};
  for (var i=0; i<product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify[productProperty]['root'] = Shopify[productProperty]['root'] || [];
      Shopify[productProperty]['root'].push(variant.option1);
      Shopify[productProperty]['root'] = Shopify.uniq(Shopify[productProperty]['root']);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify[productProperty][key] = Shopify[productProperty][key] || [];
        Shopify[productProperty][key].push(variant.option2);
        Shopify[productProperty][key] = Shopify.uniq(Shopify[productProperty][key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify[productProperty][key] = Shopify[productProperty][key] || [];
        Shopify[productProperty][key].push(variant.option3);
        Shopify[productProperty][key] = Shopify.uniq(Shopify[productProperty][key]);
      }
    }
  }

  // Update options right away.
  Shopify.updateOptionsInSelectorUpsell(0, parent, productProperty);

  if (product.options.length > 1) Shopify.updateOptionsInSelectorUpsell(1, parent, productProperty);

  if (product.options.length === 3) Shopify.updateOptionsInSelectorUpsell(2, parent, productProperty);

  // When there is an update in the first dropdown.
  $(parent + " .single-option-selector:eq(0)").change(function(e) {
    Shopify.updateOptionsInSelectorUpsell(1, parent, productProperty);
    if (product.options.length === 3) Shopify.updateOptionsInSelectorUpsell(2, parent, productProperty);
    return true;
  });

  // When there is an update in the second dropdown.
  $(parent + " .single-option-selector:eq(1)").change(function() {
    if (product.options.length === 3) Shopify.updateOptionsInSelectorUpsell(2, parent, productProperty);
    return true;
  });
};

Shopify.updateOptionsInSelectorUpsell = function(selectorIndex, parent, productProperty) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;
    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;
    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify[productProperty][key];

  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });

  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });

  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] select option').each(function() {
    if ($("."+this.value).parent('div').hasClass('soldout')) {
      $(this).html($("."+this.value).html()+'-Sold Out');
    } else {
      $(this).html($("."+this.value).html());
    }
  });

  selector.trigger('change');
};



//callback for when changing product options
selectCallbackUpsell = function(variant, selector) {

  // sections api will de-select the options, so if you look for its value, you'll find -1. If you set it to 0, it selects the first variant option.
  if(selector.variantIdField.selectedIndex == -1){
    selector.variantIdField.selectedIndex = 0
  }

  const product = document.querySelector(`.upsell-product[data-product-id='${selector.product.id}'], .upsell-product-grid[data-product-id='${selector.product.id}']`);
  const addToCartBtn = product.querySelectorAll('.upsell-add-to-cart, .upsell-grid-add-to-cart')[0];
  const hiddenProductSelect = selector.variantIdField;
  const selectedOption = hiddenProductSelect.options[hiddenProductSelect.selectedIndex];
  const productAnchor = product.querySelectorAll('.product-image-link, .product-grid-image-link');
  const productTitle = product.querySelectorAll('.product-title-link');
  const variantUrl = selectedOption.dataset.variantLink;

  // change product title and image anchor links to point to correct product
  productAnchor.forEach(pAnchor => {
    pAnchor.href = variantUrl;
  });
  productTitle.forEach(pTitle => {
    pTitle.href = variantUrl;
  });

  // change swatch product images
  // const newVariantImageUrl = selectedOption.dataset.variantImage;
  // const currentVariantImage = product.querySelector('.upsell-product-image img');
  // const new_price = product.querySelector('.upsell-product-price > span:last-child > span');
  // new_price.innerHTML = selectedOption.dataset.price;
  
  // currentVariantImage.src = newVariantImageUrl;

  if (variant && variant.available == true) {
    // if the variant exists and is available...

    // change add-to-cart btn text and state
    addToCartBtn.classList.remove('disabled');

  } else {
    // variant doesn't exist

    // change add-to-cart btn text and state
    addToCartBtn.innerText = 'Sold Out';
    addToCartBtn.classList.add('disabled');
  }


};

// add handler for add-to-cart button
const upsellAddToCartHandler = async (e) => {
  e.stopPropagation();
  e.preventDefault();
  $(".pk_cardloader").show();

  let { parentProductHandle, smartupsellProducthandle: upsellProductHandle, upsellType } = e.target.parentNode.parentNode.dataset;

  const discountCode = e.target.getAttribute("data-discount-code");
  if(discountCode && discountCode.length > 0) {
    await applyDiscountCode([discountCode]);
  }

  const selectId = e.target.closest(':is(.upsell-product, .upsell-product-grid)').dataset.selectId;
  const selectElement = document.querySelector(`#${selectId}`);
  const selectValue = selectElement.value;
  const listView = document.querySelector('.mm-listview');
  const upsellCollection = document.querySelector('.upsell-collection');

  // Fetch current cart to check for existing properties
  const cartData = await fetchCart();
  const existingItem = cartData.items.find(item => item.variant_id == selectValue);
  const existingProperties = existingItem ? existingItem.properties : {};

  // new cart item here - merge existing properties with upsell properties
  const addItemData = {
    'id': selectValue, /* for testing, change this to a variant ID on your store */
    'quantity': 1,
    'properties': {
        ...existingProperties, // preserve existing properties first
        '_upsell': true,
        '_upsellHandle': upsellProductHandle,
        '_upsellType': upsellType,
        '_upsellPdp': parentProductHandle,
    }
  };

  if(window?.location?.host === "ridgeau.com") {
    const experimental_id = "df0465b6-956d-4b12-8383-62cd2278cc0e";
    const igTestGroup = window?.igData?.user?.getTestGroup(experimental_id);

    if(igTestGroup) addItemData.properties["_igTestData"] = igTestGroup.id;

  }

  // config for fetch API
  const fetchConfig = {
    body: JSON.stringify(addItemData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  }

  // show users that POST request is happening
  listView.classList.add('miniloader');

  // make fetch POST request
  fetch('/cart/add.js', fetchConfig)
  .then((response) => response.json())
  .then((cartData) => {
    // listView.classList.remove('miniloader');
    let $addToCartBtn = $(e.target.closest('.upsell-add-to-cart, .upsell-grid-add-to-cart'));
    $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
    $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
    $addToCartBtn.find('.checkmark').addClass('checkmark-active');
    window.setTimeout(function(){
      $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
      $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
      window.setTimeout(function(){
        $addToCartBtn.find('span').removeClass('animated');
        $addToCartBtn.find('span').removeClass('fadeInDown');

      },1000)
    }, 1000);

    // hide product in upsell collection after adding to cart
    $(e.target.closest('.upsell-product')).slideUp(300).addClass('upsell-hidden');

    // if the product has a product review, hide that too
    if($(e.target.closest('.upsell-product')).next('.product-review').length) {
      $(e.target.closest('.upsell-product')).next('.product-review').slideUp(300).addClass('upsell-hidden');
    }
    // check if there are no more visible items in the upsell collection and hide entire container
    const allUpsellProducts = document.querySelectorAll('.upsell-product, .product-review');
    const allUpsellProductsArr = [...allUpsellProducts];
    const allHiddenUpsellProducts = allUpsellProductsArr.filter(product => product.classList.contains('upsell-hidden'));
    
    // debugger

    // if the number of hidden items is equal to the total number of items in the upsell collection, then all items are hidden
    if(allHiddenUpsellProducts.length === allUpsellProductsArr.length) {
      // $(upsellCollection).slideUp(300);
    }

    // if parent product is in the cart, then add _upsell: true and _upsellHandle: handle of upsell that is together with the parent product
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'GET'
    })
    .then((response) => response.json())
    .then((cartData) => {
      const parentItem = cartData.items.find(item => item.handle === parentProductHandle);
      if (parentItem) {
        const existingParentProperties = parentItem.properties || {};

        const updateItemData = {
          'id': parentItem.key,
          'properties': {
            ...existingParentProperties, // preserve existing properties first
            '_upsell': true,
            '_upsellHandle': upsellProductHandle,
          }
        };

        fetch('/cart/change.js', {
          body: JSON.stringify(updateItemData),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
          },
          method: 'POST'
        });
      }
    });

    ajaxGetCart(false);


  }).catch(function(err) {
    //something went wrong with the POST request
    alert(`Woops, looks like there was a problem adding your item to cart...please try again! - ${err}`);
  });
 
 

  // Shopify.initUpsellSwatches()
}


//init upsell swatches on load
Shopify.initUpsellSwatches = (hasSmartUpsellProductsInAcf) => {
    const upsellProducts = document.querySelectorAll('.upsell-collection .upsell-product, .upsell-collection .upsell-product-grid');
    let smartUpsellLocalStorageObj = JSON.parse(sessionStorage.getItem("smartupsell"));

    // console.log('debug------initUpsellSwatches()-----------------------------------')
    // TODO: need to make sure to add checks for if the product has relatedItems or not
    for(const product of upsellProducts) {
      let productHandle = product.dataset.smartupsellProducthandle
      const productContainer = `.upsell-product[data-product-id="${product.dataset.productId}"]`;
      let jsonData;
      if(smartUpsellLocalStorageObj && hasSmartUpsellProductsInAcf && smartUpsellLocalStorageObj[productHandle]) {
        jsonData = JSON.parse(smartUpsellLocalStorageObj[productHandle].liquid.product)
      }else {
        jsonData = JSON.parse(product.dataset.product);
      }

      const productSelectId = product.dataset.selectId;
      const swatchOption = product.querySelectorAll('.swatch_options .swatch');
      const addToCartBtn = product.querySelector('.upsell-add-to-cart, .upsell-grid-add-to-cart');

      // loop through each product's hidden select and initialize option_selector.js
      new Shopify.OptionSelectors(productSelectId, { product: jsonData, onVariantSelected: selectCallbackUpsell });
      
      // let t = Date.now()
      // console.log("debug: swatchOption: ", swatchOption)
      // console.log(`debug: ${t} - jsonData ${jsonData.id} ${jsonData.title}`)
    

      if(swatchOption.length > 0) {
        // variation issue. Delayed script to execute by 2 seconds
        setTimeout(() => {
          Shopify.linkOptionSelectorsUpsell(jsonData, productContainer);
        }, 200);
      }

      //add handler to each add-to-cart button
      addToCartBtn.addEventListener('click', upsellAddToCartHandler);
    }
}
